// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"LinkList-primaryButton-2c8GLC","row":"LinkList-row-3X9Rre"};